import CardCommon from '@op/components/CardCommon';
import React, { useEffect, useState } from 'react';
import { useIntl } from 'umi';
import PieChart from '../components/PieChart';
import { getInfluencerGenreLanguageStats } from '@op/services';
import { commonBarHIcon, pieIcon } from '@op/constants/chart';
import { transLanguage } from '@op/utils';
import BarEchart from '../components/BarEchart';
import { formatOtherInfo } from '@op/utils/chart';
import { useDownloadParams } from '@op/hooks/useDownloadParams';
import { useClickHooks } from '../hooks/useClickHooks';

export default function LanguageChart({
  filter,
  setUserSynchronousValue,
}: any) {
  const { formatMessage } = useIntl();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { downloadLegacy, downloading } = useDownloadParams();

  useEffect(() => {
    if (!filter.edition_unified_id) return;
    setLoading(true);
    setData([]);
    getInfluencerGenreLanguageStats({ ...filter, top_n: 10 })
      .then((data: any) => {
        const { list } = data || {};
        setData(
          (list || []).map((item: any) => ({
            name: item.key,
            value: item.value,
          })),
        );
      })
      .finally(() => {
        setLoading(false);
      });
  }, [filter]);

  function transLanguageInfo(lang: string) {
    return formatOtherInfo(lang, transLanguage);
  }
  const download = () => {
    downloadLegacy({
      limit: 150000,
      params: { ...filter, top_n: 10 },
      downloadFunc: 'getInfluencerGenreLanguageStats',
      sheetName: 'Filtered Creator Language Distribution',
      simpleName: 'Genre: Filtered Creator Language Distribution',
    });
  };

  const [chartType, setChartType] = useState('pie');
  const { selected, eventsDict } = useClickHooks({
    handleOnClick: (data: any) => { 
      setUserSynchronousValue(data);
    },
    data
  });

  return (
    <CardCommon
      title={formatMessage({ id: 'Language' })}
      className="language-chart-wrapper"
      operations={[pieIcon, commonBarHIcon]}
      defaultOperation="pie"
      handleOperationsOnClick={(item: any) => setChartType(item.symbol)}
      loading={loading}
      loadingHeight={425}
      hasDownload
      downloadLoading={downloading}
      handleDownloadOnClick={download}
    >
      {chartType === 'pie' ? (
        <PieChart
          data={data}
          filter={filter}
          chartType={chartType}
          translate={transLanguageInfo}
          height={425}
          selected={selected}  
          eventsDict={eventsDict}
        ></PieChart>
      ) : (
        <BarEchart
          height={425}
          filter={filter}
          selected={selected}  
          eventsDict={eventsDict}
          translate={transLanguageInfo}
          data={data}
        ></BarEchart>
      )}
    </CardCommon>
  );
}
